import { useMemo } from "react";
import { useContextLocalization } from "@/app/module/index";

export function useLocalization() {
  const { getLocalizationValue, fetchLocalizationUpdate, currentLang } =
    useContextLocalization();

  return useMemo(
    () => ({
      getText: getLocalizationValue,
      currentLang,
      changeLang: fetchLocalizationUpdate,
    }),
    [getLocalizationValue, currentLang, fetchLocalizationUpdate],
  );
}
